import { OrganType } from '@nkr/enums/organ-type';
import DonorsNav from '@nkr/views/donors/tabs';
import SwapDonorsNav from '../donors/swap-donors/nav';
import DonorProfile from '../donors/profile';
import DonorAdd from './add';

interface IProps {
    subSection: string,
    tertiarySection: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    centerId: number,
    donorId: number,
    isMicrositeParticipant: boolean,
    isFollowUpParticipant: boolean,
    isInDonorShield: boolean,
    organType: OrganType
}

const Donor = (props: IProps) => {
    return (
        <>
            {props.subSection == 'ADD' && (
                <>
                    <div style={{ padding: '0px 10px' }}>
                        <DonorsNav
                            activeKey={'ADD'}
                            centerId={props.centerId}
                            isMicrositeParticipant={props.isMicrositeParticipant}
                            isAdmin={props.isAdmin}
                            isFollowUpParticipant={props.isFollowUpParticipant}
                            isInDonorShield={props.isInDonorShield}
                            organType={props.organType}
                            onTabSelect={() => null}
                        />
                    </div>

                    <div style={{ width: '100%', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', borderBottom: '1px solid #ddd', minHeight: '70vh', paddingTop: 20, paddingLeft: 10, paddingRight: 10, backgroundColor: '#FFF' }}>
                        <SwapDonorsNav
                            activeKey={props.subSection}
                            centerId={props.centerId}
                            donorId={0}
                            recipientId={0}
                            recipientAlias={''}
                            recipientCenterId={0}
                            recipientType={null}
                            voucherHolderId={0}
                            isAdminLogin={props.isAdminLogin}
                            onTabChange={() => null} />

                        <DonorAdd centerId={props.centerId} />
                    </div>
                </>
            )}

            {props.subSection == 'PROFILE' && (
                <DonorProfile
                    subSection={props.tertiarySection}
                    isAdmin={false}
                    centerId={props.centerId}
                    donorId={props.donorId}
                    isMicrositeParticipant={props.isMicrositeParticipant}
                    isFollowUpParticipant={props.isFollowUpParticipant}
                    isInDonorShield={props.isInDonorShield}
                />
            )}
        </>
    );
}

export default Donor;